
import { useEffect, useState } from 'react';
import { db } from '@/services/firebaseService';
import { getSortableOptions } from '@/services/sortableOptionService';
import { SortableOption } from '@/types/fieldsOptions';

export const useCampExperienceOptions = () => {
  const [themeOptions, setThemeOptions] = useState<SortableOption[]>([]);
  const [allergyOptions, setAllergyOptions] = useState<SortableOption[]>([]);
  const [religiousOptions, setReligiousOptions] = useState<SortableOption[]>([]);
  const [supportOptions, setSupportOptions] = useState<SortableOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const options = await getSortableOptions(db);
        
        setThemeOptions(options.filter(opt => opt.type === 'theme')
          .sort((a, b) => a.sortOrder - b.sortOrder));
        
        setAllergyOptions(options.filter(opt => opt.type === 'allergyFriendly')
          .sort((a, b) => a.sortOrder - b.sortOrder));
        
        setReligiousOptions(options.filter(opt => opt.type === 'religiousOptions')
          .sort((a, b) => a.sortOrder - b.sortOrder));
        
        setSupportOptions(options.filter(opt => opt.type === 'supportFor')
          .sort((a, b) => a.sortOrder - b.sortOrder));
        
        setLoading(false);
      } catch (err) {
        console.error('Error fetching sortable options:', err);
        setError(err as Error);
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  return {
    themeOptions,
    allergyOptions,
    religiousOptions,
    supportOptions,
    loading,
    error
  };
};
